export const sortItems = (prev: any, curr: any, columnId: string) => {
    if (prev.original.rawData[columnId].toString().toLowerCase() > curr.original.rawData[columnId].toString().toLowerCase()) {
        return 1;
    } else if (prev.original.rawData[columnId].toString().toLowerCase() < curr.original.rawData[columnId].toString().toLowerCase()) {
        return -1;
    } else {
        return 0;
    }
};